import linkifyHtml from 'linkifyjs/html';
import Revelr from 'configs';

export default {
    defined(item) {
        return typeof item !== 'undefined' && item !== null;
    },

    nl2br(str) {
        if (!str) {
            return str;
        }

        return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
    },

    linkify(str) {
        return linkifyHtml(str);
    },

    simple_format(str) {
        return this.linkify(this.nl2br(str));
    },

    imagePath(filename) {
        return `${Revelr.assets_host || ''}/${filename}`;
    },
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/utils.jsx